import Modal from 'react-bootstrap/Modal'
import Delete from './Svg/Delete'
import { useParams } from 'react-router-dom'
import useForm from '../useForm';

function DeleteModal (props) {
  const { token} = useParams();
  const {errmsg, message, seterrmsg, setMessage} = useForm();
   const id = props.id;

  const delBankDetails = async(token, id) => {
       const delOptions = {
        method : 'DELETE',
        headers: {
          "Content-Type" : "application/json",
          "Accept": "application/json",
          'Authorization': `Bearer ${token}`
         }
       }
       await fetch(`${process.env.REACT_APP_API_URL}/bank/delete/${id}`, delOptions) 
       .then(response => response.json()) 
       .then (data => {
         if (data.msg === 'success'){
           console.log(data)
           setTimeout(() => {
            setMessage('')
            props.onHide()
            window.location.reload()
           }, 3000)
           setMessage('Deleted Successfully')
         } else{
          setTimeout(() => {
            seterrmsg('')
            props.onHide()
          })
          seterrmsg('Unable to delete , please try again')
         }
       })
       .catch(err => console.log(err))
  }

  const handleDelete = () => {
    delBankDetails(token, id)
  }

  return (
    <Modal
    {...props}
    size="md"
    aria-labelledby="contained-modal-title-vcenter"
    centered
  >
    <Modal.Header closeButton>
    <h6 className='del-head'>Delete Bank Account</h6>
    </Modal.Header>
    <Modal.Body >
     <div className="del-body">
     {message ? <p className='text-success my3 message'>{message}</p> : <p className='text-danger my3 message'>{errmsg}</p>}
     <Delete className="del-icon" fill="#EB313C" />
      <p className='del-text'>Are you sure you want to delete this account?</p>

      <div className="del-btn-group" onClick={handleDelete}>
       <p>
         Continue to Delete
       </p>
      </div>
     </div>
       
    </Modal.Body>
  </Modal>
  )
}

export default DeleteModal